import { GrpcErrorType, fetcher } from "common/helpers/fetcher"
import type {
  RecipientAddressQuery,
  RecipientAddressQueryVariables,
} from "query/graphql"
import { RecipientAddressDocument } from "query/graphql"

type AddressResponse = {
  address: string
  name: string
  picture: string
}

export const fetchRecipientAddress = async (
  address: string,
): Promise<AddressResponse | null> => {
  const metadata = await fetcher.gql<
    RecipientAddressQuery,
    RecipientAddressQueryVariables
  >({
    query: RecipientAddressDocument,
    variables: {
      address,
    },
    omittedErrors: [GrpcErrorType.NotFound, GrpcErrorType.Internal],
  })

  const ethAccount = metadata?.address?.ethAccount

  const account = {
    address,
    name: ethAccount?.name ?? address,
    picture: ethAccount?.picture ?? "",
  }

  return Promise.resolve(account)
}
